import store from '@/store';
import { EventBus } from '@/event-bus.js';
import { notify } from '@/shared/utils/browser-notify';
import i18n from '@/i18n';

export default class VoiceTransferRequestEvent {
  constructor(body) {
    const agentId = store.state.attendance.Attendance.agentId;

    window.console.log(
      '[VoiceTransferRequestEvent]',
      JSON.parse(JSON.stringify(body)),
    );

    if (body.transferFrom != agentId) {
      EventBus.$emit('setTransferName', body.transferFromName);
      store.dispatch('dialogs/openDialogTransferCallReceived');

      if (store.state.attendance.Attendance.agentAckCall) {
        let notification = {
          title: i18n.t(
            'ackCallRequest.browserNotification.transferRequestTitle',
          ),
          body: i18n.t(
            'ackCallRequest.browserNotification.transferRequestSubtitle',
            { agentName: body.transferFromName, agentId: body.transferFrom },
          ),
        };
        notify(notification, true);
      }

      return;
    }
    store.dispatch('jobs/setTransferAssistedAccepted', true);
    EventBus.$emit('enableButtonTransferAccepted');
    EventBus.$emit('enableButtonTransferCancel');
  }
}
